import { createContext } from 'react';
import { configure } from 'mobx';
import uploadStore from '@/features/User/api/UserStore';
import authStore from '@/features/Auth/api/AuthStore';
import AdminStore from '@/features/Admin/api/AdminStore';

configure({enforceActions: 'always'});

export class Store {
    uploadStore: uploadStore;
    authStore: authStore
    adminStore: AdminStore
  
    constructor() {
        this.uploadStore = new uploadStore(this);
        this.authStore = new authStore(this);
        this.adminStore = new AdminStore(this);
    }
}

export const StoreContext = createContext(new Store());